import { createFragmentContainer, graphql } from 'react-relay/legacy';

// components
import { SbSharedRefineMenuFilterDeliveryOptions } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilterDeliveryOptions';

export const SbMobileRefineMenuFilterDeliveryOptionsComponent = props => (
    <SbSharedRefineMenuFilterDeliveryOptions {...props} submitOnBlur refreshOnSumbit={false} />
);

export const SbMobileRefineMenuFilterDeliveryOptions = createFragmentContainer(
    SbMobileRefineMenuFilterDeliveryOptionsComponent,
    {
        viewer: graphql`
            fragment SbMobileRefineMenuFilterDeliveryOptions_viewer on Viewer {
                ...SbSharedRefineMenuFilterDeliveryOptions_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbMobileRefineMenuFilterDeliveryOptions_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuFilterDeliveryOptions_itemSearch
            }
        `,
    }
);
